import friedrichPic from "@/public/images/artists/friedrich.png";
import { Artist } from "@/types/types";

export const friedrich = {
  id: "157",
  name: "Friedrich",
  image: friedrichPic,
  description: `Friedrich commands a beautifully clear tenor voice. His tone is rich and subtly expressive, effortlessly evoking both depth and grace.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ffriedrich-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Classical", "Soundtrack", "Ethereal", "Falsetto"],
      secondary: ["Tenor"],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 51,
        high: 76,
      },
      sweetSpot: 69,
    },
  },
} as const satisfies Artist;
